module.exports = __webpack_public_path__ + "static/media/FullLogo.994a3e61.png";